import * as React from 'react';
import { TDocument } from '../../utils';
import CarbonDioxideMeasurementForm from './CarbonDioxideMeasurement';
import NightOximetryForm from './NightOximetry';
import SleepPolygraphyForm from './SleepPolygraphy';
import SleepStudyForm from './SleepStudy';
import SpirometryForm from './Spirometry';
import DiagnosticExaminationForm from './DiagnosticExamination';

const ClpAndCnpTestsForm = ({
  formData,
  document,
  viewing = false,
  documents,
  diagnosticExamKey,
}: IOwnProps): React.JSX.Element | null => {
  return document?._type === 'sleepPolygraphy' ? (
    <SleepPolygraphyForm formData={formData} viewing={viewing} documents={documents} />
  ) : document?._type === 'sleepStudy' ? (
    <SleepStudyForm formData={formData} viewing={viewing} documents={documents} />
  ) : document?._type === 'spirometry' ? (
    <SpirometryForm formData={formData} viewing={viewing} />
  ) : document?._type === 'nightOximetry' ? (
    <NightOximetryForm formData={formData} viewing={viewing} />
  ) : document?._type === 'carbonDioxideMeasurement' ? (
    <CarbonDioxideMeasurementForm formData={formData} viewing={viewing} />
  ) : document?._type === 'diagnosticExamination' ? (
    <DiagnosticExaminationForm
      formData={formData as IFormData<IDiagnosticExamination>}
      viewing={viewing}
      diagnosticExamKey={diagnosticExamKey}
    />
  ) : null;
};

interface IOwnProps {
  formData: IFormData<TDocument>;
  document?: TDocument;
  viewing?: boolean;
  documents: Array<any>;
  diagnosticExamKey?: TDiagnosticExamKeys;
}

export default ClpAndCnpTestsForm;
